module.exports = __webpack_public_path__ + "img/omonia.e62a2a3d.png";